import React, {Component} from 'react';
import {Modal} from 'react-bootstrap';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import * as messageConstants from '../../../shared/messages';

import './IdpMetadataPopup.scss';

class IdpMetadataPopup extends Component {
  state = {
    showModalCopyMetadata: false,
    copiedEntityId: false,
    copiedIssuer: false,
    copiedSsoRedirect: false,
    copiedSsoPost: false,
    copiedSloRedirect: false,
    copiedSloPost: false,
    downloadCertificate: false,
  }

  handleCopyText = (event) => {
    const textItem = event.currentTarget.id;
    const copied = {};

    copied[textItem] = true;
    this.setState(copied);
  }
  handleCopyTextClear = (event) => {
    const textItem = event.currentTarget.id;
    const copied = {};

    copied[textItem] = false;
    this.setState(copied);
  }
  handleDownloadXml = () => {
    this.props.idpMetadataXmlProp();
  }
  handleDownloadCertificate = () => {

    const fileData = [this.props.idpMetadata.publicKeyPemCertificate];
    const fileName = "Imprivata IDP certificate.cer";
    if (window.navigator.msSaveOrOpenBlob) {
      let blobObject = new Blob(fileData);
      window.navigator.msSaveOrOpenBlob(blobObject, fileName);
    }
    else {
      let blob = new Blob(fileData, {type: 'text/plain;charset=utf-8;'});
      let $link = document.createElement("a");
      let url = URL.createObjectURL(blob);
      $link.setAttribute("target", "_blank");
      $link.setAttribute("href", url);
      $link.setAttribute("download", fileName);
      $link.style.visibility = "hidden";
      document.body.appendChild($link);
      $link.click();
      document.body.removeChild($link);
    }
  }
  handleHideModalIdpMetadata = () => {
    this.setState({
      showModalCopyMetadata: false,
      copiedEntityId: false,
      copiedIssuer: false,
      copiedSsoRedirect: false,
      copiedSsoPost: false,
      copiedSloRedirect: false,
      copiedSloPost: false,
      downloadCertificate: false,
    });
    this.props.handleHideModalIdpMetadata();
  }

  componentDidUpdate() {
    if (this.props.errorMsg) {
      this.props.handleHideModalIdpMetadata();
    }
  }

  render() {
    const {
      idpMetadata
    } = this.props;

    const orBlock = <div className="line"><span
        className="or">{messageConstants.OR}</span></div>;
    return (
        <div className="idp-metadata-container">
          <Modal
              id="idpMetadataModal"
              show={this.props.showModalIdpMetadata}
              onHide={this.handleHideModalIdpMetadata}
              container={this}
              aria-labelledby="contained-modal-title"
              dialogClassName="idp-metadata-modal"
          >

            <Modal.Header
                className="basic-modal-header"
            >
              <Modal.Title>
                <span
                    className="basic-modal-header-title">{messageConstants.IDP_METADATA}
                </span>
                <button className="entity-id-modal-close"
                        type="button"
                        onClick={this.handleHideModalIdpMetadata}/>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body
                className="idp-metadata-modal-body">
              <div
                  className="import-modal-body-top">{messageConstants.IDP_METHODS_TEXT_USE}<b>{messageConstants.IDP_METHODS_TEXT_ONE}</b>{messageConstants.IDP_METHODS_TEXT_END}
              </div>

              <dl className="manual-idp-list">
                <dt
                    className="entry-label">{messageConstants.IDP_METADATA_URL}</dt>
                <dd>
                  <div className="copy-row">
                    <div className="entry-value"
                         id="idpIssuerUrlValue">
                      {idpMetadata.issuerUrl}
                    </div>
                    <div className="copy-link">
                      <CopyToClipboard
                          text={idpMetadata.issuerUrl}
                      >
                        {
                          this.state.copiedIssuer ? (
                              <input id="copiedIssuer"
                                     onClick={this.handleCopyTextClear}
                                     type="button"
                                     value={messageConstants.COPIED}
                                     className="button_check"/>
                          ) : (
                              <button
                                  title={messageConstants.COPY}
                                  id="copiedIssuer"
                                  className="btn btn-link"
                                  onClick={this.handleCopyText}
                              >
                                <i className="copy-mark"/>
                              </button>
                          )
                        }
                      </CopyToClipboard>
                    </div>
                  </div>
                </dd>
              </dl>
              {orBlock}
              <div className="copy-row idp-metadata-xml">
                <div className="entry-value">
                  {messageConstants.IDP_METHOD_XML}
                </div>
                <div className="copy-link">
                  <button
                      title={messageConstants.DOWNLOAD}
                      id="downloadIdpMetadataButton"
                      className="btn btn-link"
                      onClick={this.handleDownloadXml}
                  >
                    <i className="download-mark"/>
                  </button>
                </div>
              </div>
              {orBlock}
              <dl className="manual-idp-list">
                <dt className="entry-label">
                  {messageConstants.ENTITY_ID}
                </dt>
                <dd>
                  <div className="copy-row">
                    <div className="entry-value"
                         id="idpEntityIdValue">
                      {idpMetadata.issuerUrl}
                    </div>
                    <div className="copy-link">
                      <CopyToClipboard
                          text={idpMetadata.issuerUrl}
                      >
                        {
                          this.state.copiedEntityId ? (
                              <input id="copiedEntityId"
                                     onClick={this.handleCopyTextClear}
                                     type="button"
                                     value={messageConstants.COPIED}
                                     className="button_check"/>
                          ) : (
                              <button
                                  title={messageConstants.COPY}
                                  id="copiedEntityId"
                                  className="btn btn-link"
                                  onClick={this.handleCopyText}
                              >
                                <i className="copy-mark"/>
                              </button>
                          )
                        }
                      </CopyToClipboard>
                    </div>
                  </div>
                </dd>
                <dt className="entry-label">
                  {messageConstants.IDP_COPY_SSO}
                </dt>
                <dd>
                  <div className="copy-row">
                    <div className="entry-value"
                         id="idpSsoRedirectValue">
                      {idpMetadata.singleSignOnRedirectUrl}
                    </div>
                    <div className="copy-link">
                      <CopyToClipboard
                          text={idpMetadata.singleSignOnRedirectUrl}
                      >
                        {
                          this.state.copiedSsoRedirect ? (

                              <input id="copiedSsoRedirect"
                                     onClick={this.handleCopyTextClear}
                                     type="button"
                                     value={messageConstants.COPIED}
                                     className="button_check"/>
                          ) : (
                              <button
                                  title={messageConstants.COPY}
                                  id="copiedSsoRedirect"
                                  className="btn btn-link"
                                  onClick={this.handleCopyText}
                              >
                                <i className="copy-mark"/>
                              </button>
                          )
                        }
                      </CopyToClipboard>
                    </div>
                  </div>
                  <div className="copy-row">
                    <div className="entry-value"
                         id="idpSsoPostValue"
                    >
                      {idpMetadata.singleSignOnPostUrl}
                    </div>
                    <div className="copy-link">
                      <CopyToClipboard
                          text={idpMetadata.singleSignOnPostUrl}
                      >
                        {
                          this.state.copiedSsoPost ? (
                              <input id="copiedSsoPost"
                                     onClick={this.handleCopyTextClear}
                                     type="button"
                                     value={messageConstants.COPIED}
                                     className="button_check"/>
                          ) : (
                              <button
                                  title={messageConstants.COPY}
                                  id="copiedSsoPost"
                                  className="btn btn-link"
                                  onClick={this.handleCopyText}
                              >
                                <i className="copy-mark"/>
                              </button>
                          )
                        }
                      </CopyToClipboard>
                    </div>
                  </div>
                </dd>
                <dt className="entry-label">
                  {messageConstants.IDP_COPY_SLO}
                </dt>
                <dd>
                  <div className="copy-row">
                    <div className="entry-value"
                         id="idpSloRedirectValue">
                      {idpMetadata.singleLogoutRedirectUrl}
                    </div>
                    <div className="copy-link">
                      <CopyToClipboard
                          text={idpMetadata.singleLogoutRedirectUrl}
                      >
                        {
                          this.state.copiedSloRedirect ? (

                              <input id="copiedSloRedirect"
                                     onClick={this.handleCopyTextClear}
                                     type="button"
                                     value={messageConstants.COPIED}
                                     className="button_check"/>

                          ) : (
                              <button
                                  title={messageConstants.COPY}
                                  id="copiedSloRedirect"
                                  className="btn btn-link"
                                  onClick={this.handleCopyText}
                              >
                                <i className="copy-mark"/>
                              </button>
                          )
                        }
                      </CopyToClipboard>
                    </div>
                  </div>
                  <div className="copy-row">
                    <div className="entry-value"
                         id="idpSloPostValue">
                      {idpMetadata.singleLogoutPostUrl}
                    </div>
                    <div className="copy-link">
                      <CopyToClipboard
                          text={idpMetadata.singleLogoutPostUrl}
                      >
                        {
                          this.state.copiedSloPost ? (
                              <input id="copiedSloPost"
                                     onClick={this.handleCopyTextClear}
                                     type="button"
                                     value={messageConstants.COPIED}
                                     className="button_check"/>
                          ) : (
                              <button
                                  title={messageConstants.COPY}
                                  id="copiedSloPost"
                                  className="btn btn-link"
                                  onClick={this.handleCopyText}
                              >
                                <i className="copy-mark"/>
                              </button>
                          )
                        }
                      </CopyToClipboard>
                    </div>
                  </div>
                </dd>

                <dd className="copy-row idp-metadata-xml">
                  <div className="entry-value">
                    {messageConstants.IDP_METHOD_CERTIFICATE}
                  </div>
                  <div className="copy-link">
                    <button
                        title={messageConstants.DOWNLOAD}
                        id="downloadIdpCertificateButton"
                        className="btn btn-link"
                        onClick={this.handleDownloadCertificate}
                    >
                      <i className="download-mark"/>
                    </button>
                  </div>
                </dd>
              </dl>
            </Modal.Body>
          </Modal>
        </div>
    );
  }

}

export default IdpMetadataPopup;
